import { DateComparatorFilter } from '../shared/controls/formatters';

export const getCommonTextFilterParams = () => ({
  buttons: ['apply', 'reset'],
  closeOnApply: true,
  suppressAndOrCondition: true,
});

export const getCommonNumberFilterParams = () => ({
  buttons: ['apply', 'reset'],
  closeOnApply: true,
  suppressAndOrCondition: true,
  inRangeInclusive: true,
});

export const getSetFilterParams = (values = []) => ({
  values,
  buttons: ['apply', 'reset'],
  closeOnApply: true,
  defaultToNothingSelected: true,
  applyButtonDisabled: (params) => params.filterModel?.values?.length === 0,
});

export const getSetCheckboxFilterParams = (values = []) => ({
  values: [true, false],
  buttons: ['apply', 'reset'],
  closeOnApply: true,
  defaultToNothingSelected: true,
  suppressSyncValuesAfterDataChange: true,
  refreshValuesOnOpen: false,
  applyButtonDisabled: (params) => !params.filterModel?.values?.length,
});

const currentYear = new Date().getFullYear();

export const getSetDatefilterParams = () => ({
  comparator: DateComparatorFilter,
  minValidYear: 2000,
  maxValidYear: currentYear,
  inRangeFloatingFilterDateFormat: 'DD MM YYYY',
  buttons: ['apply', 'reset'],
  closeOnApply: true,
  suppressAndOrCondition: true,
  inRangeInclusive: true,
});
